module Meevo.Plugins.Paging {
    'use strict';

    import IPagingSettings = Meevo.Model.PagingFieldsSettings;

    export class MainSection extends PagingBaseSection {
        public model: IPagingSettings;
        private DEPENDENT_FIELDS: string[] = [
            'appointmentCheckInEnable',
            'noShowEnable',
            'runningLateEnable',
            'appointmentBookEnable',
            'appointmentEditEnable',
            'appointmentCancelEnable'
        ];

        constructor(params: ISectionParamsPaging) {
            super(params);
        }

        getData(): void {
            this.context.loadingInProgress = true;
            this.pagingService.getPagingSettings().then((response: any) => {
                this.model = response;
            }).finally(() => {
                this.context.loadingInProgress = false;
            });
        }

        customSave() {
            return this.pagingService.updatePagingSettings(this.model);
        }

        onEnableSettingsToggled() {
            for (let field of this.DEPENDENT_FIELDS) {
                if (this.model.hasOwnProperty(field)) this.model[field] = this.model.pagingEnable;
            }
        }

    }
}
